import controller from './billfold.controller';
import template from './billfold.view.html';

let BillfoldComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default BillfoldComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/reports/billfold/billfold.component.js
 **/